import React from 'react';
import {IonBackButton, IonButtons, IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonContent, IonHeader, IonPage, IonTitle, IonToolbar} from '@ionic/react';

const ServiceLocationsVA: React.FC = () => {
    return (
        <IonPage>
            <IonHeader>
                <IonToolbar color="primary">
                    <IonButtons slot="start">
                        <IonBackButton defaultHref="/Help/servicelocations"/>
                    </IonButtons>
                    <IonTitle>Service Location: VA</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent fullscreen>
                <iframe title="PA Map" src="https://www.google.com/maps/embed/v1/place?key=AIzaSyC-C99R1wtlYAZdY8SxrbY_te_Exs7Tfus&q=5600+Midlothian+Turnpike,Richmond+VA">
                </iframe>
                <IonCard>
                    <IonCardContent>
                        <h1>5600 Midlothian Turnpike</h1>
                        <h2>Richmond, VA 23225</h2>
                    </IonCardContent>
                </IonCard>
                <IonCard>
                    <IonCardHeader>
                        <IonCardTitle>Directions</IonCardTitle>
                    </IonCardHeader>
                    <IonCardContent>
                        Coming Soon!
                    </IonCardContent>
                </IonCard>
            </IonContent>
        </IonPage>
    );
};

export default ServiceLocationsVA;
